import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { Field, Label, Switch as HeadlessSwitch } from '@headlessui/react';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  // Shown after the switch and clickable, like a checkbox label.
  label?: ReactNode;
  disabled?: boolean;
  className?: string;
}

// An on/off switch with an optional label beside it.
export const Switch: FC<Props> = ({
  checked,
  onChange,
  label,
  disabled = false,
  className,
}) => (
  <Field className={classNames(styles.field, className)} disabled={disabled}>
    <HeadlessSwitch
      checked={checked}
      onChange={onChange}
      className={styles.track}
    >
      <span aria-hidden className={styles.thumb} />
    </HeadlessSwitch>
    {label && <Label className={styles.label}>{label}</Label>}
  </Field>
);

const styles = {
  field: 'inline-flex items-center gap-2.5 data-disabled:opacity-60',
  track: classNames(
    'group relative inline-flex h-5 w-9 flex-none cursor-pointer items-center rounded-full p-0.5',
    'bg-ink-tertiary/40 data-checked:bg-accent-fill',
    'focus:outline-none data-focus:ring-2 data-focus:ring-accent-ink/40 data-focus:ring-offset-2 data-focus:ring-offset-surface-card',
    'data-disabled:cursor-default',
  ),
  thumb:
    'size-4 rounded-full bg-white shadow-sm transition-transform duration-200 ease-out group-data-checked:translate-x-4',
  label: 'cursor-pointer text-sm text-ink-primary',
};
